import { MarkerDataModel } from '@/models/marker/marker';
import { getGradeRange, scoreValidation } from '@/utils/utils';
import moment from 'moment';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'portfolio-info',
})

export default class PortfolioInfoComponent extends Vue {

    // -----------------------------------------------------------
    // Properties

    @Prop({default: []})
    private portfolioContent: any;

    @Prop()
    private showcaseData!: MarkerDataModel;

    @Prop()
    private selectedCollection: any;

    // ------------------------------------------------------------
    // Hooks


    // ------------------------------------------------------------
    // Actions

    private onChangeScore(event: any, collection: any) {
        scoreValidation(event, 100);
        this.loadData(collection);
    }

    private onSelectContent(content: any) {
        this.loadData(content);
    }

    private onChangeTime(content: any) {
        this.loadData(content);
    }

    private updateScore(collection: any) {
        this.loadData(collection);
    }

    // -------------------------------------------------------------
    // Methods

    private getGradeRange(value: number) {
        return getGradeRange(value);
    }

    private loadData(collectionData: any) {
        const { result } = this.showcaseData;
        result.score = parseInt(collectionData.score, 0);
        result.timeSpent = moment.duration(collectionData.timespent).asMilliseconds();
    }
}
